/* 借入相談受付完了 本文 */
import React, { memo } from 'react';
import HeadingM from '../../molecules/HeadingM';
import ApplicationInformation from '../../molecules/ApplicationInformation';
import FooterPreExaminationApplicationInputComplete from '../../organisms/FooterPreExaminationApplicationInputComplete';

interface Props {
  ja_name: string;
  reception_cd: string;
  is_staff: boolean;
  opened_mypage: boolean;
  guarantors_num: number;
}

const Finish: React.FC<Props> = ({
  ja_name,
  reception_cd,
  is_staff,
  opened_mypage,
  guarantors_num,
}) => {
  // 完了メッセージ
  const setCompletedMsg = () => {
    // 連帯債務者等ありの場合
    if (guarantors_num > 0) {
      return (
        <div className="p-lead">
          お客様のお申込みを受け付けました。
          <br />
          ご登録のメールアドレスに借入相談受付メールを送信しました。
          <br />
          またご登録の連帯債務者等の方に申込内容確認のためのマイページ開設招待メールを送信しました。
          <br />
          連帯債務者等がいる場合、現在は申込処理は完了していません。連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
          <br />
          連帯債務者等の確認状況はマイページから確認可能です。
          <br />
          連帯債務者等の方にメールが届かない場合にはマイページから本申込み案件を開き、メールの再送信を行って下さい。
          <br />
          本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
          <br />
          メールが届かない場合にはお申込みJAにお問合せ下さい。連絡先の電話番号はJAバンクホームページからご確認下さい。
          <br />
          お問合せの際には申込番号が必要です。
        </div>
      );
    }

    // 連帯債務者等なしの場合
    return (
      <div className="p-lead">
        お客様のお申込みを受け付けました。
        <br />
        ご登録のメールアドレスに借入相談受付メールを送信しました。
        <br />
        本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
        <br />
        メールが届かない場合にはお申込みJAにお問合せ下さい。連絡先の電話番号はJAバンクホームページからご確認下さい。
        <br />
        お問合せの際には申込番号が必要です。
      </div>
    );
  };

  return (
    <>
      <HeadingM label="借入相談受付完了"></HeadingM>
      {setCompletedMsg()}
      <ApplicationInformation ja_name={ja_name} reception_cd={reception_cd} />
      <FooterPreExaminationApplicationInputComplete
        is_staff={is_staff}
        opened_mypage={opened_mypage}
      />
    </>
  );
};

export default memo(Finish);
